
class BottomBarMenuSelectors {

    getGoBackButtonSelector(element)
    {
        return '.bottom_bar_menu_item_back';
    }


    getBookingPaymentsLinkSelector()
    {
        return '.bottom_bar_menu_item_back_booking_payments';
    }

    getAddPassengerButtonSelector()
    {
        return '.bottom_bar_menu_item_add_passenger';
    }

}

